<div class="upload-popup-form">
  <div class="form-inline">
    <h3 class="vox-heading-3" translate>company.dids.activate-testing-did.add-data.portability.upload-docs.signed-doc.title</h3>
    <div class="form-group">
      <div class="drop-zone" #d1 (dragenter)="onDragEnter($event, d1)" (dragleave)="onDragLeave($event, d1)" (drop)="onDrop($event, 'module')" (dragover)="onDragOver($event)"  translate>
        company.dids.activate-testing-did.add-data.portability.upload-docs.signed-doc.placeholder
        <span translate>company.dids.activate-testing-did.add-data.portability.upload-docs.signed-doc.separator</span>
        <label class="vox-btn vox-btn-secondary" for="module" translate>company.dids.activate-testing-did.add-data.portability.upload-docs.signed-doc.button
          <i class="fa fa-upload"></i>
          <input #module (change)="onChangeFile($event, 'module')" [accept]="allowedExtensions" id="module" type="file"/>
        </label>
      </div>
      <div class="upload-popup-form__file-name" *ngIf="files.module">
        <span>{{ files.module.name }}</span>
        <button type="button" (click)="removeFile('module', module)" >
          <i class="icon-small-delete"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="form-inline">
    <h3 translate>company.dids.activate-testing-did.add-data.portability.upload-docs.last-invoice-doc.title</h3>
    <div class="form-group">
      <div class="drop-zone" #d2 (dragenter)="onDragEnter($event, d2)" (dragleave)="onDragLeave($event, d2)" (drop)="onDrop($event, 'invoice')" (dragover)="onDragOver($event)" translate>
        company.dids.activate-testing-did.add-data.portability.upload-docs.last-invoice-doc.placeholder
        <span translate>company.dids.activate-testing-did.add-data.portability.upload-docs.last-invoice-doc.separator</span>
        <label class="vox-btn vox-btn-secondary" for="invoice" translate>company.dids.activate-testing-did.add-data.portability.upload-docs.last-invoice-doc.button
          <i class="fa fa-upload"></i>
          <input #invoice (change)="onChangeFile($event, 'invoice')" [accept]="allowedExtensions" id="invoice" type="file" />
        </label>
      </div>
      <div class="upload-popup-form__file-name" *ngIf="files.invoice">
        <span>{{ files.invoice.name }}</span>
        <button type="button" (click)="removeFile('invoice', invoice)">
          <i class="icon-small-delete"></i>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="enableIdentity" class="form-inline">
    <h3 translate>company.dids.activate-testing-did.add-data.portability.upload-docs.identity-doc.title</h3>
    <div class="form-group">
      <div class="drop-zone" #d3 (dragenter)="onDragEnter($event, d3)" (dragleave)="onDragLeave($event, d3)" (drop)="onDrop($event, 'identity')" (dragover)="onDragOver($event)" translate>
        company.dids.activate-testing-did.add-data.portability.upload-docs.identity-doc.placeholder
        <span translate>company.dids.activate-testing-did.add-data.portability.upload-docs.identity-doc.separator</span>
        <label class="vox-btn vox-btn-secondary" for="identity" translate>company.dids.activate-testing-did.add-data.portability.upload-docs.identity-doc.button
          <i class="fa fa-upload"></i>
          <input #identity id="identity" (change)="onChangeFile($event, 'identity')" [accept]="allowedExtensions" type="file" />
        </label>
      </div>
      <div class="upload-popup-form__file-name" *ngIf="files.identity">
        <span>{{ files.identity.name }}</span>
        <button type="button" (click)="removeFile('identity', identity)">
          <i class="icon-small-delete"></i>
        </button>
      </div>
    </div>
  </div>
</div>